import { useContext } from 'react';

import SearchAndFilterContext, { SearchAndFilterValues } from './context';

const useSearchAndFilter = (): SearchAndFilterValues => useContext(SearchAndFilterContext);

export default useSearchAndFilter;
